var FilterParam;
(function (FilterParam) {
    FilterParam["TitleInclude"] = "titleInclude[]";
    FilterParam["CampaignTypes"] = "campaignTypes[]";
    FilterParam["RetailPrice"] = "retailPrice[]";
    FilterParam["RetailerIds"] = "retailerIds[]";
    FilterParam["CategoryIds"] = "categoryIds[]";
    FilterParam["SubcategoryIds"] = "subCategoryIds[]";
    FilterParam["BrandIds"] = "brandIds[]";
    FilterParam["SiteId"] = "siteId";
    FilterParam["VersionId"] = "versionId";
})(FilterParam || (FilterParam = {}));
const getFilterParamKeyFromValue = (value) => {
    const entry = Object.entries(FilterParam).find(([, filterValue]) => {
        return filterValue === value;
    });
    return entry === null || entry === void 0 ? void 0 : entry[0];
};

export { FilterParam, getFilterParamKeyFromValue };
//# sourceMappingURL=filters.js.map
